// 判断是否在游戏浏览器
export const isMiniWorldGame = typeof window.GetUrlAddAuthStr === 'function';

// 判断是否是移动端
export const isMobile = /(iPhone|iPad|iPod|iOS|Android)/gi.test(
  navigator.userAgent,
);

// 判断是否是 pc 端
export const isPc = !isMobile;
